import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_OBJECT_BUILDER_HANDLER = {
  topic: TOPIC_NAMES.OPEN_OBJECT_BUILDER,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/ObjectBuilder')
};